
const minPerSlide = 4

document.querySelectorAll('.carousel[data-carousel-type="vaCarousel"].carousel--single-items').forEach(
    (carousel) => {
        let items = carousel.querySelectorAll('.carousel-item')
        items.forEach((el: HTMLElement) => {
            let next = el.nextElementSibling
            for (let i = 1; i < minPerSlide; i++) {
                if (!next) {
                    // wrap carousel by using first child
                    next = items[0]
                }
                let cloneChild = next.cloneNode(true) as HTMLElement
                el.appendChild(cloneChild.children[0])
                next = next.nextElementSibling
            }
        })
    }
)

document.querySelectorAll('[data-bs-slide="next"], [data-bs-slide="prev"]').forEach((el) => {
    const carouselSelector = el.getAttribute('data-bs-target')
    const carousel = document.querySelector(carouselSelector)
    if (!carousel) {
        return;
    }

    el.addEventListener('click', () => {
        document.querySelectorAll('[data-stop-carousel-cycle="' + carousel + '"]')
            .forEach((cycleButton) => {
                const icon = cycleButton.querySelector('.bi')
                if (!icon) {
                    return
                }
                icon.classList.remove('bi-play-fill')
                icon.classList.add('bi-pause-fill')
            })
    });
})

document.querySelectorAll('[data-stop-carousel-cycle]').forEach(e => {
    e.addEventListener('click', () => {
        const myCarouselElement = document.getElementById(e.getAttribute('data-stop-carousel-cycle'))
        if (!myCarouselElement) {
            return;
        }
        const carousel = bootstrap.Carousel.getInstance(myCarouselElement)
        if (!carousel) {
            return;
        }
        const icon = e.querySelector('.bi')
        let currentStatus = icon.classList.contains('bi-pause-fill') ? 'playing' : 'paused'
        if (currentStatus === 'playing') {
            icon.classList.remove('bi-pause-fill')
            icon.classList.add('bi-play-fill')
            carousel.pause();
        } else {
            icon.classList.remove('bi-play-fill')
            icon.classList.add('bi-pause-fill')
            carousel.cycle()
        }
    })
})